import { useEffect } from "react";
import * as _ from "lodash";
import { useSelector } from "react-redux";
import { displayToast } from "src/shared/helpers/toaster.helper";
import { useAppDispatch } from "src/store/hooks";
import { setSocketRealTimeUpdate } from "src/store/slices/asset.slice";
import { getUserInfo } from "src/core/auth/auth.service";

type UseSocketAckOptions = {
  ackKey: string;
  onAck?: (socketData: any) => void | Promise<void>;
  assetCode?: string | null;
};

export function useSocketAck({
  ackKey,
  onAck,
  assetCode,
}: UseSocketAckOptions) {
  const dispatch = useAppDispatch();
  const user = getUserInfo();

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  useEffect(() => {
    const userId =
      user[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ];

    if (userId !== socketRealTimeUpdateData?.NotificationIdentifier) return;

    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate?.[ackKey]) {
      if (
        socketRealTimeUpdateData?.AssetCode &&
        assetCode &&
        socketRealTimeUpdateData?.AssetCode !== assetCode
      )
        return;

      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor,
      );

      copiedSocketRealTimeUpdate[ackKey] = false;
      dispatch(setSocketRealTimeUpdate(copiedSocketRealTimeUpdate));

      onAck?.(socketRealTimeUpdateData);
    }
  }, [
    socketRealTimeUpdate,
    socketRealTimeUpdateData,
    dispatch,
    ackKey,
    onAck,
    user,
  ]);
}

export function useShowToaster() {
  const user = getUserInfo();

  return (socketRealTimeUpdateData: any) => {
    const userId =
      user[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ];

    if (userId === socketRealTimeUpdateData?.NotificationIdentifier) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor,
      );
    }
  };
}
